import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Default from './Default'
import ErrorPage from '../ErroPage/ErrorPage'
import ThemeScope from '../../theme/ThemeScope'

const DynamicRouteHandler = () => {
    const { dynamicPath } = useParams()
    const [couponId, setCouponId] = useState(null)

    let slug
    if (dynamicPath.startsWith('cupom-desconto-')) {
        slug = dynamicPath.replace('cupom-desconto-', '')
    } else if (dynamicPath.startsWith('hot-area-')) {
        slug = dynamicPath.replace('hot-area-', '')
    } else {
        return <ErrorPage />
    }

    const page = <Default slug={slug} couponId={couponId || null} />

    // Hot areas (clubes) mantêm o tema padrão, independente do tema ativo
    return dynamicPath.startsWith('hot-area-') ? <ThemeScope>{page}</ThemeScope> : page
}

export default DynamicRouteHandler
